import { HttpInterceptorFn } from '@angular/common/http';
import { getTenantId } from '../utils/tenant';

export const tenantInterceptor: HttpInterceptorFn = (req, next) => {
  // If request is going to the legacy chatbot backend, skip attaching the custom header to avoid CORS errors
  if (req.url.includes('api-ai.myshopyglam.com')) {
    return next(req);
  }

  const tenantId = getTenantId();
  const modifiedReq = req.clone({
    headers: req.headers.set('X-Tenant-ID', tenantId),
  });
  return next(modifiedReq);
};
